// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"afdcf645","216":"5d85aaa0","403":"8e699a29","723":"85bca778","753":"e5dcf34c","900":"438c806e"}[chunkId] + ".chunk.js";
};